import React, { useState } from "react";
import { currencyText } from "theme/utils";
import Spinner from "theme/Spinner";
import { Icon } from "antd";
import Quantity from "./quantity";
import { addBasket } from "actions/productDetail";
import { useDispatch, useSelector } from "react-redux";

import "./style.less";

const MiscProduct = ({ product = {} }) => {
  const dispatch = useDispatch();
  const { basketPending } = useSelector((state) => state.productDetail);
  const [quantity, setQuantity] = useState(1);
  const {
    pk,
    name,
    price,
    currency_type,
    attributes: { extra_product_url: link, extra_product: description },
  } = product;
  const productImage = product.productimage_set[0].image;
  const exactLink = `https://www.thefashionstore.be${link}`;

  const addToBasket = () => dispatch(addBasket(quantity, pk));

  if (!product) return null;

  return (
    <div>
      <div className="misc-product__gift-text">
        <Icon type="bulb" />
        <p>Voeg een 2de artikel toe om te genieten van korting</p>
      </div>
      <div className="misc-product__wrapper">
        <div className="misc-product__content">
          <a href={exactLink} rel="noopener noreferrer" target="_blank">
            <img className="misc-product__image" src={productImage} alt="" />
          </a>
          <div className="misc-product__description">
            <a
              className="misc-product__description-title"
              href={exactLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              {name}
            </a>
            <p className="misc-product__description-desc">{description}</p>
            <a
              className="misc-product__description-link"
              href={exactLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              Meer info
            </a>
          </div>
          <Quantity quantity={quantity} setQuantity={setQuantity} />
          <div className="misc-product__price">
            {currencyText(currency_type)}{" "}
            {(+price).toFixed(2).replace(".", ",")}
          </div>
          <div className="misc-product__add-to-cart">
            <button
              className="misc-product__button"
              onClick={addToBasket}
              disabled={basketPending}
            >
              {basketPending ? <Spinner /> : undefined}
              VOEG TOE AAN WINKELWAGEN
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiscProduct;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/basket/miscProduct/index.js